import { useForm } from "../../../provider/Form/FormProvider";
import FormSubmitProps from "../../../types/FormSubmitProps";
import React from "react";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import wizardStyle from "../wizardStyle";
import Typography from "@mui/material/Typography";
import { Box, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormFader from "../Common/Fader/FormFader";
import FormLegend from "../Common/FormLegend/FormLegend";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import EmploymentContractDetailsEnforceClaim from "./EmploymentContractDetailsEnforceClaim";
import EmploymentContractDetailsDefendClaim from "./EmploymentContractDetailsDefendClaim";

type EmploymentContractDetailsProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

export default function EmploymentContractDetails({ product, submitProps }: EmploymentContractDetailsProps) {
  const { handleSubmit, values } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Details zu Ihrem Anliegen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>Details zu Ihrem Anliegen</strong>
              </FormLegend>
            </Grid>

            {values.caseCategory === "enforceClaim" && <EmploymentContractDetailsEnforceClaim product={product} submitProps={submitProps} />}
            {values.caseCategory === "defendClaim" && <EmploymentContractDetailsDefendClaim product={product} submitProps={submitProps} />}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
